import React from 'react';
import { Form } from 'antd';
import { Checkbox } from '../../../../components/base/Checkbox';
import { useAppSelector } from '../../../../hooks/store';
import { getUniversity } from '../../../../redux/selectors';
export var TermsFormItems = function () {
    var university = useAppSelector(getUniversity);
    return (React.createElement(Form.Item, { name: "terms", valuePropName: "checked", rules: [
            function (_a) {
                var getFieldValue = _a.getFieldValue;
                return ({
                    validator: function () {
                        var tetmValue = getFieldValue('terms');
                        if (!tetmValue) {
                            return Promise.reject(new Error('Please agree to the terms to be able to use this service'));
                        }
                        return Promise.resolve();
                    },
                });
            },
        ] },
        React.createElement(Checkbox, { className: 'text-[1rem]' },
            "I am over the age of 16 and consent to my personal data being processed by ",
            university.name,
            "\u00A0according to their\u00A0",
            React.createElement("a", { href: university.privacy_policy, target: "_blank", rel: "noopener noreferrer", className: "text-brand-orange" }, "Privacy Policy"),
            "\u00A0 and being shared with The Ambassador Platform according to their\u00A0",
            React.createElement("a", { href: "https://legal.theambassadorplatform.com/privacy-notice?hsLang=en", target: "_blank", rel: "noopener noreferrer", className: "text-brand-orange" }, "Privacy Notice"),
            "\u00A0 and ",
            React.createElement("a", { href: "https://legal.theambassadorplatform.com/", target: "_blank", rel: "noopener noreferrer", className: "text-brand-orange" }, "terms"),
            "\u00A0, so that they can facilitate content generation for ",
            university.name,
            " and messaging interactions with prospects")));
};
